import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function MemberList() {
  const active_pro_name = localStorage.getItem('selected_project_name');
  const [listProjectMembersArray, setListProjectMembersArray] = useState([]);
  const [filterdListProjectMembersArray, setFilterdListProjectMembersArray] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
    setPermissions(storedPermissions);

    const active_pro_id = localStorage.getItem('selected_project_id');
    var obj = {
      pro_id: active_pro_id
    };

    fetch('getAllProjectMember.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.json()) // same as your original (not JSON)
      .then(result => {
        console.log(result);

        var res = result;

        if (res !== 'fail' && res !== '') {
          try {
            var memarr = res;

            // If your backend actually returns JSON string, then use this instead:
            // var memarr = JSON.parse(res);

            if (Array.isArray(memarr)) {
              var len = memarr.length;

              if (len < 1) {
                document.getElementById('memnum').innerText = '0';
                getAllactiveId(memarr);
              } else {
                document.getElementById('memnum').innerText = len;
                getAllactiveId(memarr);
                setListProjectMembersArray(memarr);
              }
            } else {
              document.getElementById('memnum').innerText = '0';
              setListProjectMembersArray([]);
            }

          } catch (e) {
            console.error("Invalid JSON from backend:", e);
            document.getElementById('memnum').innerText = '0';
            setListProjectMembersArray([]);
          }
        } else {
          showAlert('Cannot find any active member for this project.');
          document.getElementById('memnum').innerText = '0';
          setListProjectMembersArray([]);
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }, [])

  function getAllactiveId(arr) {
    var activeIdarr = [];
    var len = arr.length;
    for (var i = 0; i < len; i++) {
      var activeid = arr[i].memberid;
      var memorgid = localStorage.getItem('member_id');
      if (activeid === memorgid) {
        var prorole = arr[i].member_role;
        localStorage.setItem('mem_proj_role', prorole);
      }
      activeIdarr.push(activeid);
    }
    loadFullMemList(activeIdarr);
    //setTimeout(loadFullMemList, 2000) 
  }

  function loadFullMemList(acitveids) {
    var memlistarr = [];
    var comid = localStorage.getItem('mem_company_id');
    var obj = {
      mem_com_id: comid
    };

    fetch('get_Tm_list.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.json()) // because PHP returns json_encode($data)
      .then(result => {
        if (result !== 'fail') {
          let memlistarr = result;

          console.log(memlistarr);

          createActiveList(memlistarr, acitveids);
        } else {
          alert('Cannot create list.');
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }

  function createActiveList(arr, acitveids) {
    const filterids = arr.filter(member => !acitveids.includes(member.primary_key));
    localStorage.setItem('filtermemlist', JSON.stringify(filterids));
    setFilterdListProjectMembersArray(filterids);
  }
  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function getMembersDetails(orgmemid, proid) { 
      localStorage.setItem('selectedComMemberID',orgmemid);
       localStorage.setItem('initialpage', 'members');
       navigate('/member_details');
  }

  function removeMem(id) {
    var obj = {
      primary_key: id
    };

    fetch('removeProMem.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.text()) // IMPORTANT: not json()
      .then(result => {
        result = result.trim(); // remove unwanted spaces/newlines

        if (result !== 'fail' && result !== '') {
          showAlert('Removed successfully');
          localStorage.setItem('initialpage', 'members');
          navigate('/redirect_task');
        } else {
          showAlert('Cannot remove member.');
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }

  function openAddMemPop() {
    $('#addMempop').css('display', 'block');
  }

  function clsoeMemPop() {
    $('#addMempop').css('display', 'none');
  }

  function addMember(idnum) {

    document.getElementById('loaderpops').classList.add('activDisplay')
    var trgid = 'memlist' + idnum;
    var project_id = localStorage.getItem('selected_project_id');
    var project_name = localStorage.getItem('selected_project_name');
    var member_id = $('#' + trgid + ' #member_primary_key').val();
    var memberemail = $('#' + trgid + ' #member_email').val();
    var member_name = $('#' + trgid + ' #memname').text();
    var member_com_id = $('#' + trgid + ' #new_mem_com_id').text();
    var member_role = $('#' + trgid + ' #memrole').text();

    var obj = {
      proid: project_id,
      proname: project_name,
      memberid: member_id,
      membername: member_name,
      mem_com_id: member_com_id,
      status_member: 'Normal',
      member_role: member_role,
      memberemail: memberemail
    };

    console.log(obj);

    fetch('save_the_team.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.text()) // IMPORTANT: because PHP returns plain text (ID)
      .then(result => {
        console.log(result);

        if (result !== 'fail' && result !== '') {
          // result = your $ptm_id
          sendEmailToUsers(
            member_id,
            memberemail,
            project_name,
            project_id,
            member_name
          );
        } else {
          alert('Cannot add member. Please try once again.');
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }

  function sendEmailToUsers(memberid, mememail, proname, proid, membername) {

    var memid = memberid;
    var mememail = mememail;
    var proname = proname;
    var comname = localStorage.getItem('mem_company_name');
    var companyemail = localStorage.getItem('useremail');
    var proid = proid;
    var member_name = membername;

    var obj = {
      memid: memid,
      mememail: mememail,
      proname: proname,
      comname: comname,
      companyemail: companyemail,
      proid: proid,
      membername: member_name
    };

    console.log(obj);

    fetch('send_user_email.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.text()) // IMPORTANT: text(), not json()
      .then(result => {
        console.log("Response:", result);

        // check success based on your PHP response
        if (result.includes('Success')) {
          clsoeMemPop();
          localStorage.setItem('initialpage', 'members');
          navigate('/redirect_task');
        } else {
          alert('Cannot create account. Please try again.');
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
        alert('Server error occurred. Check console for details.');
      });

  }
  return (
    <div>
      <div className='topbar_menu'>
        {permissions.includes("project.manage") && (
          <button className='member_button  addmembtn' onClick={openAddMemPop}>Add Member</button>
        )}
        <p>Project name : {active_pro_name}</p>
        <p>Current Number Of Member : <span id="memnum"></span></p>
      </div>
      <div className='member_row'>

        <div className='member_details'>
          <section className='vl_dsh_bodypart_section pos_rel'>

            <div className='vl_listing_area'>
              
              {Array.isArray(listProjectMembersArray) && listProjectMembersArray.map((item, index) => {

                return (
                  <div className='resource_card_one_third' key={index}>
                    <div className='resource_inner'>
                    <div className='fullwidth pull_left pt-21'>
                      <h4 className='prj_name'>{item.membername}</h4>
                      <input id="com_id" type="hidden" value={item.mem_com_id} />
                      <input id="member_main_id" type="hidden" value={item.memberid} />
                      <input id="member_mail" type="hidden" value={item.memberid} />
                      <input id="member_primary_key" type="hidden" value={item.primary_key} />
                      <input id="proid" type="hidden" value={item.proid} />
                      <span>Role : {item.member_role}</span>
                    </div>
                    <div className='divider'>&nbsp;</div>

                    <div className='vl_dsh_one_half'>
                      <p>Project: {item.proname}</p>
                    </div>
                    <div className='vl_dsh_one_half'>
                      <p>Status: {item.status_member}</p>
                    </div>
                    {permissions.includes("project.manage") && (
                      <div className='list_buttonholder'>
                        <button onClick={() => { getMembersDetails(item.memberid, item.proid) }}>View Member</button>
                        <button className='rightgap backtranparent' onClick={() => { removeMem(item.primary_key) }}><i className='ri-delete-bin-3-fill'></i></button>
                      </div>
                    )}
                  </div>
                  </div>
                )
              })}
            </div>
          </section>
        </div>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button> 
          </div>
        </div>
      </div>
      <div className='vl_dsh_popup' id="addMempop">
        <div className='memlistarea'>
          <button className='popcls' onClick={clsoeMemPop}>X</button>
          <div className='memlistcontainer'>
            <div className='vl_listing_area'>
              <div className='vl_listing_row listheading_row'>
                <div className='vl_listing_cell width25'>
                  <h4 className='prj_name'>Member's Name</h4>
                </div>
                <div className='vl_listing_cell width20'>
                  <p>Company Name</p>
                </div>

                <div className='vl_listing_cell width25'>
                  <p>Member Skills</p>
                </div>

                <div className='vl_listing_cell width20'>
                  <p>Action</p>
                </div>
              </div>
              {filterdListProjectMembersArray.map((item, index) => (
                <div className='vl_listing_row' id={`memlist${index}`}>
                  <div className='vl_listing_cell width25' key={index}>
                    <h4 className='prj_name' id="memname">{item.mem_fname} {item.mem_lname}</h4>
                    <input id="new_mem_com_id" type="hidden" value={item.mem_com_id} />
                    <input id="member_email" type="hidden" value={item.mem_email} />
                    <input id="member_primary_key" type="hidden" value={item.primary_key} />
                    <input id="comname" type="hidden" value={item.company_name} />
                    <span >Role : <span id="memrole">{item.mem_role}</span></span >
                  </div>


                  <div className='vl_listing_cell width20'>
                    <p>{item.company_name}</p>
                  </div>
                  <div className='vl_listing_cell width25'>
                    <p>{item.mem_skills}</p>
                  </div>
                  <div className='vl_listing_cell width20'>
                    <button onClick={() => { addMember(index) }}>Add Member</button>

                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='loaderpop' id="loaderpops">
        <div className='loader_inner'>
          <p>New member added. Page will refresh automatically</p>
        </div>
      </div>
    </div>
  )
}


